// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { TaxDetail_FederalTaxDetailFragment, TaxDetail_StateTaxDetailFragment, TaxDetail_StateInheritanceTaxDetailFragment, TaxDetail_GstTaxDetailFragment, TaxDetail_GiftTaxDetailFragment, TaxDetail_StateGiftTaxDetailFragment } from '../../../taxes/graphql/TaxDetail.generated';
import { gql } from '@apollo/client';
import { TaxDetail_FederalTaxDetailFragmentDoc, TaxDetail_StateTaxDetailFragmentDoc, TaxDetail_StateInheritanceTaxDetailFragmentDoc, TaxDetail_GstTaxDetailFragmentDoc, TaxDetail_GiftTaxDetailFragmentDoc, TaxDetail_StateGiftTaxDetailFragmentDoc } from '../../../taxes/graphql/TaxDetail.generated';
export type GiftingProposalProjectionFragment = { __typename?: 'GiftingProposalProjections', inEstateValueAfterTax: CurrencyUSD, inEstateValueBeforeTax: CurrencyUSD, outOfEstateCharitableValue: CurrencyUSD, outOfEstateFamilyValue: CurrencyUSD, outOfEstateTotalValue: CurrencyUSD, taxableGift: CurrencyUSD, totalValue: CurrencyUSD, remainingLifetimeExemption: CurrencyUSD, lifetimeExemptionAppliedTowardGiftTax: CurrencyUSD, giftTax: CurrencyUSD, scenarioId: string, yearInEstatePortfolioDepleted?: number | null, scenario: { __typename?: 'GiftingProposalScenario', order: number, displayName: string, isDefault: boolean, isBaseline: boolean, id: string }, estateTaxSummaryV2: { __typename?: 'TaxSummaryV2', _cacheKey: string, federalTax?: (
      { __typename?: 'FederalTaxDetail' }
      & TaxDetail_FederalTaxDetailFragment
    ) | null, stateTax?: Array<(
      { __typename?: 'StateTaxDetail' }
      & TaxDetail_StateTaxDetailFragment
    )> | null } };

export const Operations = {
  Fragment: {
    GiftingProposalProjection: 'GiftingProposalProjection' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const GiftingProposalProjectionFragmentDoc = gql`
    fragment GiftingProposalProjection on GiftingProposalProjections {
  inEstateValueAfterTax
  inEstateValueBeforeTax
  outOfEstateCharitableValue
  outOfEstateFamilyValue
  outOfEstateTotalValue
  taxableGift
  totalValue
  remainingLifetimeExemption
  lifetimeExemptionAppliedTowardGiftTax
  giftTax
  scenarioId
  yearInEstatePortfolioDepleted
  scenario {
    order
    displayName
    isDefault
    isBaseline @client
    id
  }
  estateTaxSummaryV2 {
    _cacheKey
    federalTax {
      ...TaxDetail_FederalTaxDetail
    }
    stateTax {
      ...TaxDetail_StateTaxDetail
    }
  }
}
    ${TaxDetail_FederalTaxDetailFragmentDoc}
${TaxDetail_StateTaxDetailFragmentDoc}`;